export class MessageBoxButton {
    public id: string;
    public text: string;

    constructor(id: string, text?: string) {
        this.id = id;
        this.text = id;

        if (text) {
            this.text = text;
        }
    }
}
